import { createIcon } from '@chakra-ui/icons';

export const ThumbsDown = createIcon({
  displayName: 'ThumbsDown',
  viewBox: '0 0 16 16',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M4.9458 9.59375V1.59375"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
      />
      <path
        d="M6.66044 14.0909L5.12972 9.59524H1.6123V1.92857L10.0559 1.08422C10.9703 0.992776 11.8293 1.5362 12.1384 2.4016L14.3094 8.48011C14.6195 9.34844 13.9758 10.2619 13.0537 10.2619H8.94564L9.06584 13.6486C9.0907 14.348 8.53037 14.9286 7.83057 14.9286C7.30144 14.9286 6.83097 14.5918 6.66044 14.0909Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>,
  ],
});
